<template>
    <div id="community">
        <div class="head">
            <p>{{ community.community.title }}</p>
            <p>{{ communityCity }}</p>
        </div>

        <div class="community_desc">
            <div class="features">
                <p class="_title">Community Features</p>
                <p class="feature">{{ community.acres }}</p>
                <p v-for="(feat, i) in featureList()" :key="i" class="feature">{{ feat }}</p>

                <p class="feature">Local Schools</p>
                <div>
                    <ul>
                        <li class="feature" v-for="(feat, i) in schoolList()" :key="i">{{ feat }}</li>
                    </ul>
                </div>

                <router-link tag="button" :to="{ name: 'Contact' }" id="request_more">Request More</router-link>
            </div>
            <div class="community_images">
                <img :src="renderImage" alt="">
            </div>
        </div>

        <div class="plat">
            <img @click.stop="community.openPlat = true" class="plat-img"
                 :src="community.community.plat_src" :alt="`${community.name} Plat`">
            <!-- TODO - insert the description of the home here. -->
            <v-container fluid>
                <v-layout align-center justify-center>
                    <v-dialog v-model="community.openPlat" :scrollable="false" max-width="1000px">
                        <v-card>
                            <v-layout align-center justify-center>
                                <img :alt="`${community.name} Plat`" class="modal-img"
                                    :src="community.community.plat_src">
                            </v-layout>
                        </v-card>
                    </v-dialog>
                </v-layout>
            </v-container>
        </div>

        <div class="plans">
            <p class="plans_title">Availabe Plans:</p>
            <div class="community_plans" v-for="(plan, i) in parsePlans" :key="i" v-if="plan.disabled === false">
                <router-link tag="img" :to="{ path: '/plans/' + plan.plan_name }"
                             :src="plan.thumbnail"></router-link>
                <div>
                    <router-link :to="{ path: '/plans/' + plan.plan_name }">{{ plan.title }}</router-link>
                    <p>Total Sq Ft: {{ plan.total_size }}</p>
                    <p>Bedrooms: {{ bedrooms(plan) }}</p>
                    <p>Bathrooms: {{ plan.bathrooms }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const data = {
        community: {
            community: [],
            openPlat: false,
            indexSchool: 999,
            name: '',
            community_images: [],
            imageFolder: 'https://elitecrafthomes.com/static_files/images/communities',
            planFolder: 'https://elitecrafthomes.com/static_files/images/plans',
            plans: [],
            platImage: '',
            images: {}
        }

    };

    import axios from 'axios'

    const apiToken = require('../../../credentials').API_TOKEN;
    const urlPath = require('../../../credentials').URL_PATH;

    export default {
        name: 'Community',
        data() {
            return data;
        },
        computed: {
            renderImage() {
                if (this.community !== undefined && this.community !== 'undefined') {
                    return this.community.images.src;
                }
            },
            communityCity() {
                if (this.community.community.location !== undefined && this.community.community.location !== 'undefined') {
                    return this.community.community.location.city;
                }
            },
            parsePlans() {
                return this.community.plans;
            }
        },
        methods: {
            bedrooms(plan) {
                return plan.bedrooms.toLocaleString().length === 2 ?
                    `${plan.bedrooms.toLocaleString()[0]}-${plan.bedrooms.toLocaleString()[1]}` : plan.bedrooms;
            },
            schoolList() {
                let tempFeat = null;
                if (this.community.community.features !== undefined && this.community.community.features !== 'undefined') {
                    tempFeat = this.community.community.features;
                    let featList = [];
                    let schoolIndex = 999;
                    for (let i = 0; i < tempFeat.length; i++) {
                        if (tempFeat[i] === 'Schools') {
                            schoolIndex = i;
                        }
                        if (schoolIndex !== 999 && tempFeat[i].toLowerCase().includes('school') && i !== schoolIndex) {
                            featList.push(tempFeat[i])
                        }
                    }
                    return featList;
                }
            },
            featureList() {
                let tempFeat = null;
                if (this.community.community.features !== undefined && this.community.community.features !== 'undefined') {
                    tempFeat = this.community.community.features;
                    let featList = [];
                    for (let i = 0; i < tempFeat.length; i++) {
                        if (!tempFeat[i].toLowerCase().includes('school')) {
                            featList.push(tempFeat[i])
                        }
                    }
                    return featList;
                }
            },
            hydrateComms() {
                axios.get(urlPath + `communities/communities/${this.$route.params.name}/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.community.name = this.$route.params.name;
                        this.community.community = res.data;
                        this.community.community.plat_src
                    })
            },

            loadPlans() {
                axios.get(urlPath + 'plans/plans/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.community.plans = [];
                        for (let i = 0; i < res.data.length; i++) {
                            if (this.community.community.plans[i].toLowerCase().includes(res.data[i].plan_name.toLowerCase())) {
                                this.community.plans.push({
                                    plan_name: res.data[i].plan_name,
                                    // url: `https://elitecrafthomes.com/plans/${res.data[i].plan_name}`,
                                    total_size: res.data[i].total_size,
                                    bedrooms: res.data[i].bedrooms,
                                    bathrooms: res.data[i].bathrooms,
                                    disabled: res.data[i].disabled,
                                    thumbnail: res.data[i].thumbnail_src,
                                    title: res.data[i].title
                                })
                            }
                        }

                    })
            },

            hydrateImages() {
                axios.get(urlPath + 'communities/images/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then(res => {
                        this.community.images = [];
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].community === this.community.name) {
                                this.community.images = res.data[i];
                                break;
                            }
                        }
                    })
            }
        },
        created() {
            this.hydrateComms();
            this.loadPlans();
            this.hydrateImages()
        },
        mounted() {
            this.hydrateImages();
        }
    }
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    @font-face {
        font-family: "LibreBaskerville Italic";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Italic.ttf")
    }

    #community {
        div.head {
            text-align: center;
            p:nth-of-type(1) {
                font-size: 32px;
                font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
                font-weight: bold;
                margin: 50px 0 0 0;
                padding: 0;
            }
            p:nth-of-type(2) {
                font-size: 24px;
                font-family: 'LibreBaskerville Italic', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
                margin: 0 0 50px 0;
                padding: 0;
            }
        }

        div.community_desc {
            max-width: 1200px;
            width: 100%;
            text-align: center;
            margin: 0 auto 50px auto;
            position: relative;

            div.features {
                text-align: left;
                width: 30%;
                display: inline-block;
                padding-right: 25px;
                p._title {
                    font-weight: bold;
                    font-size: 20px;
                    text-decoration: underline;
                }
                .feature {
                    font-size: 18px;
                    font-weight: 300;
                    padding: 6px 0;
                    margin: 0;
                }
                ul {
                    margin-left: 25px;
                    padding-bottom: 25px;
                    li.feature {
                        padding: 0;
                        margin: 0;
                    }
                }

                #request_more {

                    font-size: 20px;
                    border: 3px solid white;
                    background-color: #425152;
                    color: white;
                    width: 165px;
                    padding: 7px 0;
                    text-decoration: none;
                    text-align: center;
                    -webkit-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                    -moz-box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                    box-shadow: -1px 2px 3px 1px rgba(0, 0, 0, 0.71);
                }
            }

            div.community_images {
                display: inline-block;
                max-width: 500px;
                width: 100%;
                img {
                    max-width: 500px;
                    width: 100%;
                    max-height: 560px;
                    min-height: 350px;
                    height: 100%;
                    object-fit: fill;

                }
            }
        }


    }

    div.plat {
        text-align: center;
        margin-bottom: 50px;
        img {
            max-width: 530px;
            min-width: 400px;
            width: 100%;
            max-height: 790px;
            min-height: 600px;
            height: 100%;
            object-fit: contain;
            cursor: pointer;
        }
    }

    .modal-img {
        max-width: 750px;
        min-width: 650px;
        width: 100%;
        max-height: 800px;
        min-height: 700px;
        height: 100%;
        object-fit: fill;
    }

    @media screen and (min-width: 1025px) {
        .plans {
            margin: 0 auto;
            text-align: center;
            max-width: 1200px;
            width: 100%;
            p.plans_title {
                font-size: 20px;
                text-align: left;
                font-weight: 700;
                padding-left: 60px;
            }
            .community_plans {
                position: relative;
                max-width: 255px;
                width: 255px;
                height: 300px;
                display: inline-block;
                text-align: center;
                margin: 15px 10px 25px 10px;
                img {
                    max-width: 255px;
                    width: 255px;
                    max-height: 167px;
                    height: 167px;
                    object-fit: fill;
                    cursor: pointer;
                }
                div {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    text-align: center;
                    margin: 0 auto;
                    a:nth-of-type(1) {
                        font-weight: 600;
                        font-size: 20px;
                        padding-bottom: 10px;
                        text-align: center;
                        text-decoration: none;
                        color: black;
                    }
                    p {
                        font-weight: 400;
                        padding: 0;
                        margin: 0;
                        text-align: center;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        .plans {
            padding: 0 10px;
            margin: 0 auto 50px auto;
            text-align: center;
            max-width: 600px;
            width: 100%;
            p.plans_title {
                font-size: 20px;
                text-align: left;
                font-weight: 700;
            }
            .community_plans {
                position: relative;
                max-width: 255px;
                width: 255px;
                height: 285px;
                display: inline-block;
                text-align: center;
                img {
                    max-width: 255px;
                    width: 255px;
                    max-height: 167px;
                    height: 167px;
                    object-fit: fill;
                }
                div {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    text-align: center;
                    margin: 0 auto;
                    a:nth-of-type(1) {
                        font-weight: 600;
                        font-size: 20px;
                        padding-bottom: 10px;
                        text-align: center;
                        text-decoration: none;
                        color: black;
                    }
                    p {
                        font-weight: 400;
                        padding: 0;
                        margin: 0;
                        text-align: center;
                    }
                }
            }
            .community_plans:nth-child(even) {
                margin: 0 35px 35px 0;

            }

            .community_plans:nth-child(odd) {
                margin: 0 0 35px 35px;
            }
        }
    }

    @media screen and (max-width: 450px) {
        .modal-img {
            max-width: 300px;
            max-height: 500px;
            width: 100%;
            height: 100%;
        }

        .plat-img {
            max-width: 100vw;
            max-height: 600px;
            min-height: 400px;
            width: 100%;
            height: 100%;
        }
        #community {
            div.head {
                text-align: center;
                p {
                    font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
                }
                p:nth-of-type(1) {
                    font-size: 28px;
                    font-weight: bold;
                    margin: 50px 0 0 0;
                    padding: 0;
                }
                p:nth-of-type(2) {
                    font-size: 24px;
                    margin: 0 0 50px 0;
                    padding: 0;
                }
            }

            div.community_desc {
                max-width: 100vw;
                width: 100%;
                text-align: center;
                padding: 0 10px;
                display: block;
                div.features {
                    width: 100%;
                    padding-right: 0;
                    text-align: center;
                    margin-bottom: 50px;

                    p._title {
                        text-align: left;
                    }

                    .feature {
                        text-align: left;
                    }
                    #request_more {
                        font-size: 18px;
                        width: 170px;
                        height: 60px;
                    }
                }

                div.community_images {
                    display: block;
                    max-width: 100vw;
                    img {
                        max-width: 100vw;
                    }
                }
            }

            div.plat {
                margin: 50px auto;
                img {
                    max-width: 100vw;
                    min-width: auto;
                    max-height: 600px;
                }
            }

            .plans {
                margin: 50px auto 75px auto;
                max-width: 100vw;
                padding: 0 10px;
                p.plans_title {
                    text-align: center;
                    padding-left: 0;
                    font-size: 18px;
                    font-weight: 700;
                }
                .community_plans {
                    position: relative;
                    height: 150px;
                    width: auto;
                    max-width: inherit;
                    display: inherit;
                    margin: 0;

                    img {
                        max-width: 167px;
                        width: 167px;
                        max-height: 152px;
                        height: 152px;
                    }
                    div {
                        position: absolute;
                        width: 50vw;
                        top: 50%;
                        margin: 0;
                        -webkit-transform: translateY(-50%);
                        -moz-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        -o-transform: translateY(-50%);
                        transform: translateY(-50%);

                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            text-decoration: none;
                            color: black;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                }
            }



            .community_plans:nth-child(odd) {
                img {
                    float: left;
                }

                div {
                    right: 0;
                    padding-left: 20px;
                    text-align: left;
                    a, p {
                        text-align: left;
                    }
                }
            }

            .community_plans:nth-child(even) {
                img {
                    position: absolute;
                    right: 0;
                }
                div {
                    text-align: right;
                    left: 0;
                    padding-right: 20px;
                    a, p {
                        text-align: right;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/communities/Community.vue